<script lang="ts" setup>
import { useModalsStore } from '@/stores/modals';
import { computed } from 'vue';

import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const { toggleModal } = useModalsStore();
const { closeModal } = useModalsStore();

</script>

<template src="./modal-new.html"></template>